import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import { MapService } from 'src/app/Service/map.service';
import Feature from 'ol/Feature';
import { Icon, Style } from 'ol/style';
import { BingMaps, XYZ } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import * as olProj from 'ol/proj';
import { Point } from 'ol/geom';
import Vector from 'ol/source/Vector';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import momentJalaali from 'moment-jalaali';

declare let $: any;

@Component({

  selector: 'app-new-student',

  templateUrl: './new-student.component.html',

  styleUrls: ['./new-student.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class NewStudentComponent implements OnInit {

  showResult: boolean = false;

  list_StudentData: any = {};

  source: any;

  vector: any;

  layers: any = [];

  map: any;

  list_Schools: any = [];

  baseLocation: any = [51.3833554, 35.6770113];

  myControl = new FormControl();

  filteredOptions!: Observable<string[]>

  selectedSchool: any = []

  userSchool: any = []

  filteredSchools = [];

  searchT_School = '';

  iMobileDomain: string = '';

  bAvatar: boolean = false;

  isLoading: boolean = false;

  bReCalDistance: boolean = false;

  strAvatar: string = '';

  list_Grade: any = [];

  list_Class: any = [];

  list_CarType: any[] = [];

  lstDistrict: any[] = [];

  lstLevel_List: any[] = [];

  lstSchoolType: any[] = [];

  lst_City: any = [];

  bPersonnel: boolean = false;

  latoLong: FormGroup = this.formBuilder.group({

    latIn: new FormControl(''),

    longIn: new FormControl(''),

    strMobile: new FormControl('')

  })

  dateFilter: FormGroup = this.formBuilder.group({

    strExpireDate: new FormControl(`${momentJalaali().jYear()}/03/31`)

  })

  mdlSchool: FormGroup = this.formBuilder.group({

    strCity: new FormControl('', Validators.required),

    tiEducationDistrict: new FormControl('', Validators.required),

    tiEducationLevel: new FormControl('', Validators.required),

    tiSchoolType: new FormControl('', Validators.required),

    tiGender: new FormControl('', Validators.required),

  })

  @Input() std_PhoneNumber!: string | undefined;

  @Input() isContracts: boolean = false;

  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  @Output() isDataLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private location: Location,

    private Notification: NotificationService,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private OtherService: OtherService,

    private route: ActivatedRoute,

    private router: Router,

  ) { }

  ngOnInit(): void {

    // console.log([1, 2, 3, 4, [5, 6, 7, 8, 9, 10, 1, 2, 3, 4, 5, 6, 3, 10, 10, 10], [5, 6, 7, 8,]].flat().reduce((acc: any, curr: any) => {

    //   acc[curr] = (acc[curr] || 0) + 1;

    //   return acc;

    // }, {}))


    this.route.url.subscribe((segment) => {

      if (segment[0].path == 'personnel') {

        this.bPersonnel = true;

      }

      else {

        this.initSchool();

      }

      this.getSchools();

      if (this.std_PhoneNumber != undefined) {

        this.searchByNumber();

      }

      this.bReCalDistance = JSON.parse(this.gurdService.decrypt(localStorage.getItem('menu') as string)!).bReCalDistance;

    })

    if (this.isContracts) {

      this.showResult = true;

      this.list_StudentData = {

        strCity: '',

        strNationalCode: ''

      }

      // this.list_StudentData = undefined;

    }

  }

  async initSchool() {

    var model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strCity: this.mdlSchool.get('strCity')?.value

    };

    if (this.mdlSchool.get('strCity')?.value == '') {

      // let res4 = JSON.parse((await axios.post(`TaxiLon_City_List`, model)).data);

      let res4 = JSON.parse((await axios.post(`City_List4StudentRegister`, model)).data);

      this.OtherService.nonespinner();

      this.lst_City = res4;

      // console.log(res4)

    }

    else {

      // let res = JSON.parse((await axios.post(`EducationDistrict_List`, model)).data.toString());

      let res = JSON.parse((await axios.post(`EducationDistrict_List4StudentRegister`, model)).data.toString());

      this.lstDistrict = res;

      // console.log(res)

      // -----------------------------------------------------------

      // let res2 = JSON.parse((await axios.post(`EducationLevel_List`, model)).data.toString());

      let res2 = JSON.parse((await axios.post(`EducationLevel_List4StudentRegister`, model)).data.toString());

      this.lstLevel_List = res2;

      // console.log(res2)

      // -----------------------------------------------------------

      // let res3 = JSON.parse((await axios.post(`SchoolType_List`, model)).data.toString());

      let res3 = JSON.parse((await axios.post(`SchoolType_List4StudentRegister`, model)).data.toString());

      this.lstSchoolType = res3;

      // console.log(res3);


    }

  }

  filterSchool() {

    if (this.searchT_School == '') {

      this.filteredSchools = [];

      this.iMobileDomain = '';

    }

    else this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));
  }

  goBack() {

    this.location.back();
  }

  newOpenMap() {

    this.latoLong.get('latIn')?.setValue('');

    this.latoLong.get('longIn')?.setValue('');

    $('#maplat').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }



      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat(this.baseLocation),

          zoom: 16,

        }),

      });

      const marker = new Feature({

        geometry: new Point(olProj.fromLonLat(this.baseLocation)),

      });

      const vectorLayer = new VectorLayer({

        source: new VectorSource({

          features: [marker],

        }),

        style: new Style({

          image: new Icon({

            src: '../../assets/Img/marker4.png',

            scale: 1.0,

          }),

        }),

      });

      this.map.addLayer(vectorLayer);

      this.map.on('click', (e: any) => {

        this.map.removeLayer(vectorLayer)

        if (e.dragging) return;

        var coords = olProj.toLonLat(e.coordinate);

        this.latoLong.controls['latIn'].setValue(coords[1])

        this.latoLong.controls['longIn'].setValue(coords[0])

        var iconGeometry = new Point(e.coordinate)

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.getLayers().forEach((layer: VectorSource) => {

          if (layer?.getKeys().length < 11)

            this.map.removeLayer(layer);
        });

        this.map.addLayer(dinamicPinLayer);
      })

      this.map.on('pointermove', (e: any) => {

        var pixel = this.map.getEventPixel(e.originalEvent);

        var hit = this.map.hasFeatureAtPixel(pixel);

        this.map.getViewport().style.cursor = 'pointer';

      });

    }, 500);

  }

  setValue_Filter(event: any) {

    this.iMobileDomain = event.iMobileDomain;

  }

  async getAddress() {

    var strAddress = document.getElementById('strAddress') as HTMLInputElement;

    if (strAddress.value != '') {

      let res = (await axios.post(`Geocoding`, { 'strAddress': strAddress.value }));

      if (res.data.fLat != 0 && res.data.fLon != 0) {

        this.baseLocation = [res.data.fLon, res.data.fLat];

        this.newOpenMap()
      }

      else this.newOpenMap()
    }

    else this.newOpenMap()

  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

    // console.log(res)

    // /------------------------------------------------------------------

    let Grade_List = JSON.parse((await axios.post(`Grade_List`, model)).data.toString());

    this.list_Grade = Grade_List;

    // /------------------------------------------------------------------

    let ClassNo_List = JSON.parse((await axios.post(`ClassNo_List`, {})).data.toString())

    this.list_Class = ClassNo_List;

  }

  async studentSearch(form: any) {

    if (form.invalid) return this.Notification.showError('شماره موبایل را وارد کنید');

    else {

      this.iMobileDomain = ''

      this.selectedSchool = '';

      this.strAvatar = '';

      this.searchT_School = '';

      var model = {

        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        strMobile: form.value.strMobile

      }

      this.dateFilter.controls['strExpireDate'].setValue(`${momentJalaali().jYear()}/03/31`);

      this.isLoading = true;

      let res = JSON.parse((await axios.post(`School_Passenger_Search`, model)).data.toString());

      this.isLoading = false;

      if (res?.iResult == 0) return this.Notification.showError(res.strError);

      this.list_StudentData = res[0];

      if (this.list_StudentData != undefined) {

        this.setCity({ strCity: res[0].strCity })

        this.strAvatar = res[0].strAvatar;

        res[0].fDistance = res[0]?.fDistance + ' کیلومتر'

        this.iMobileDomain = res[0].iMobileDomain

        this.searchT_School = this.bPersonnel ? res[0].strMobileDomain_strComment : res[0].strCombinedDescription;

        if (this.list_StudentData.strExpireDate.trim() != '') this.dateFilter.controls['strExpireDate'].setValue(this.list_StudentData.strExpireDate.trim());

      }

      this.latoLong.controls['strMobile'].setValue(model.strMobile)

      this.latoLong.controls['latIn'].setValue(res[0]?.fOrigiLat)

      this.latoLong.controls['longIn'].setValue(res[0]?.fOriginLon)

      this.showResult = true;

    }

  }

  setCity(event) {

    if (event?.strCity) {

      if (this.list_StudentData) {

        this.list_StudentData.strCity = event.strCity;

        this.mdlSchool.get('strCity')?.setValue(event.strCity);

        this.initSchool();

      }

      else {

        this.list_StudentData = {

          strCity: '',

          strNationalCode: ''

        }

        this.list_StudentData.strCity = event.strCity;

        this.mdlSchool.get('strCity')?.setValue(event.strCity);

        this.initSchool();


      }

    }

    else {

      this.list_StudentData.strCity = '';

      this.mdlSchool.get('strCity')?.setValue('');


    }


  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this.OtherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  async searchByNumber() {

    this.iMobileDomain = ''

    this.selectedSchool = '';

    this.OtherService.Showspinner()

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: this.std_PhoneNumber

    }

    this.dateFilter.controls['strExpireDate'].setValue(`${momentJalaali().jYear()}/03/31`);

    let res = JSON.parse((await axios.post(`School_Passenger_Search`, model)).data.toString());

    this.OtherService.nonespinner();

    this.isDataLoaded.emit(true)

    this.list_StudentData = res[0];

    this.iMobileDomain = ''

    this.searchT_School = '';

    if (this.list_StudentData != undefined) {

      this.setCity({ strCity: res[0].strCity })

      this.strAvatar = res[0].strAvatar;

      res[0].fDistance = res[0]?.fDistance + ' کیلومتر'

      this.iMobileDomain = res[0].iMobileDomain

      this.searchT_School = res[0].strMobileDomain_strComment;

      if (this.list_StudentData.strExpireDate.trim() != '') this.dateFilter.controls['strExpireDate'].setValue(this.list_StudentData.strExpireDate.trim());

    }

    this.latoLong.controls['strMobile'].setValue(model.strMobile)

    this.latoLong.controls['latIn'].setValue(res[0]?.fOrigiLat)

    this.latoLong.controls['longIn'].setValue(res[0]?.fOriginLon)

    this.showResult = true;

  }

  async calcDistance(item: any) {

    if (item == '' || this.latoLong.value.latIn == undefined) return this.Notification.showError('مدرسه و محل سکونت را وارد کنید')

    const selectedSchool = this.list_Schools.find((a: any) => {

      return a.iMobileDomain == this.iMobileDomain

    })

    const school = this.selectedSchool.length == 1 ? this.selectedSchool : selectedSchool;

    if ((school?.length != 1 && school?.length != undefined) || (school?.length != undefined && school?.length != 1)) return this.Notification.showError('ابتدا مدرسه را انتخاب کنید');

    if (this.latoLong.value.latIn == '') return this.Notification.showError('آدرس محل سکونت را وارد کنید');

    else {

      this.OtherService.Showspinner()

      var model = {

        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

        fSLat: this.latoLong.value.latIn,

        fSLon: this.latoLong.value.longIn,

        fDLat: school.length == undefined ? school.fLat : school[0].fLat,

        fDLon: school.length == undefined ? school.fLon : school[0].fLon,

      }

      let res = JSON.parse((await axios.post(`CalDistanceBetween2Point`, model)).data.toString());

      this.OtherService.nonespinner()

      var input = document.getElementById('distance') as HTMLInputElement;

      input.value = `${res} کیلومتر`;

      this.list_StudentData.fDistance = `${res} کیلومتر`;

    }

  }

  async confirmLatol() {

    var fOriginLon = document.getElementById('fOriginLon') as HTMLInputElement;

    var fOrigiLat = document.getElementById('fOrigiLat') as HTMLInputElement;

    var strAddress = document.getElementById('strAddress') as HTMLInputElement;

    fOriginLon.value = this.latoLong.controls['longIn'].value;

    fOrigiLat.value = this.latoLong.controls['latIn'].value;

    let model = {

      fLat: fOrigiLat.value,

      fLon: fOriginLon.value,

    }

    const address = await axios.post(`ReverseGeocoding`, model);

    strAddress.value = address.data.strAddress;

    $('#maplat').modal('hide');

  }

  async newStudent(student: NgForm) {

    if (student.invalid) return this.Notification.showError('لطفا موارد ضروری را وارد کنید');

    else {

      var fOriginLon = document.getElementById('fOriginLon') as HTMLInputElement;

      var fOrigiLat = document.getElementById('fOrigiLat') as HTMLInputElement;

      var strAddress = document.getElementById('strAddress') as HTMLInputElement;

      var distance = document.getElementById('distance') as HTMLInputElement;

      var form = student.value;

      form['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

      form['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

      form['strMobile'] = this.latoLong.value.strMobile || 'no';

      form['iMobileDomain'] = this.iMobileDomain;

      form['strCity'] = this.list_StudentData ? this.list_StudentData.strCity : '';

      form['strExpireDate'] = this.dateFilter.value.strExpireDate;

      form.fDistance = distance.value != '' ? distance.value.replace(' کیلومتر', '') : 0;

      form.fOrigiLat = fOrigiLat.value != '' ? fOrigiLat.value : 0;

      form.fOriginLon = fOriginLon.value != '' ? fOriginLon.value : 0;

      form.strAddress = strAddress.value != '' ? strAddress.value : '';

      form.strNationalCode = form.strNationalCode != null ? form.strNationalCode : '';

      form.strAvatar = this.bAvatar ? this.strAvatar : '';

      if (this.list_StudentData?.iPassenger == undefined || this.isContracts) {

        $.confirm({
          title: `آیا از ذخیره اطلاعات اطمینان دارید ؟`,
          content: '',
          type: 'success',
          buttons: {
            ok: {
              text: "ذخیره",
              btnClass: 'btn-success',
              keys: ['enter'],
              action: async () => {

                this.isLoading = true;

                let res = JSON.parse((await axios.post(`School_Passenger_Save`, form)).data.toString());

                this.isLoading = false;

                if (res.iResult == 0) return this.Notification.showError(res.strError);

                else {

                  this.Notification.showSuccess('عملیات با موفقیت انجام شد');

                  this.showResult = false;

                  this.closeModal.emit(res)

                }


              }
            },
            cancel: {

              text: "لغو",

            }
          }
        });

      }

      else {

        form['iPassenger'] = this.list_StudentData.iPassenger;

        $.confirm({
          title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,
          content: '',
          type: 'blue',
          buttons: {
            ok: {
              text: "ویرایش",
              btnClass: 'btn-primary',
              keys: ['enter'],
              action: async () => {

                this.isLoading = true;

                let res = JSON.parse((await axios.post(`School_Passenger_Edit`, form)).data.toString());

                this.isLoading = false;

                if (res.iResult == 0) return this.Notification.showError(res.strError);

                else {

                  this.Notification.showSuccess('عملیات با موفقیت انجام شد');

                  if (this.std_PhoneNumber == undefined) this.showResult = false;

                  this.closeModal.emit()

                }


              }
            },
            cancel: {

              text: "لغو",

            }
          }
        });

      }

    }

  }

  async deleteStudent() {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              iPassenger: this.list_StudentData.iPassenger

            };

            let res = JSON.parse((await axios.post(`School_Passenger_Delete`, model)).data.toString())

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('عملیات با موفقیت انجام شد');

              this.showResult = false;

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async costCalculate() {

    if (this.list_StudentData?.fDistance == '') return this.Notification.showError('ابتدا فاصله منزل تا مدرسه را محاسبه کنید');

    this.OtherService.Showspinner()

    let resp = await axios.post(`GetMobileType`);

    resp.data.unshift({ tiMobileType: -1, strComment: 'انتخاب کنید' })

    this.list_CarType = resp.data;

    this.OtherService.nonespinner();

    var options = '';

    this.list_CarType.forEach(function (item) {

      options += '<option value="' + item.tiMobileType + '">' + item.strComment + '</option>';

    });

    $.confirm({

      title: `نوع خودرو را مشخص کنید`,

      content: `<select class="form-control" id="mySelect">${options}</select>`,

      type: 'blue',

      buttons: {

        ok: {

          text: "محاسبه هزینه ",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            var selectedValue = $('#mySelect').val();

            if (selectedValue == '-1') return this.Notification.showError('لطفا نوع خودرو را مشخص کنید !!');

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              iPassenger: this.list_StudentData.iPassenger,

              tiMobileType: selectedValue,

            }

            this.OtherService.Showspinner()

            let res = JSON.parse((await axios.post(`School_ServiceFee_Cal`, model)).data.toString());

            this.OtherService.nonespinner();

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            res = !res.length ? res : res[0]

            var message = " کرایه خالص راننده : " + `<span class='text-success fw-bold'> ${res.iBaseCost?.toLocaleString()} ریال </span>` + "<br/>" +
              " تامین اجتماعی : " + `<span class='text-success fw-bold'> ${res.iInsurance?.toLocaleString()} ریال </span>` + "<br/>" +
              " آموزش و پرورش : " + `<span class='text-success fw-bold'> ${res.iEducation?.toLocaleString()} ریال </span>` + "<br/>" +
              " شهرداری : " + `<span class='text-success fw-bold'> ${res.iMunc?.toLocaleString()} ریال </span>` + "<br/>" +
              " شرکت : " + `<span class='text-success fw-bold'> ${res.iCompany?.toLocaleString()} ریال </span>` + "<br/>" +
              " پرداختی اولیا : " + `<span class='text-success fw-bold'> ${res.iFinalCost?.toLocaleString()} ریال </span>` + "<br/><br/>"

            $.confirm({

              title: `تعرفه سرویس به شرح زیر می باشد : `,

              content: `${message}`,

              type: 'blue',

              buttons: {

                cancel: {

                  text: "بستن",

                  btnClass: 'btn-secondary px-5',

                }

              }

            });

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.Notification.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.strAvatar = base64String;

        this.strAvatar = this.strAvatar.replace('data:image/jpeg;base64,', '');

      };

    }


  }

  async updateSchool(form: NgForm) {

    this.list_Schools = [];

    setTimeout(() => {

      this.selectedSchool = '';

      this.searchT_School = '';

      this.list_Schools.push({ iMobileDomain: 0, strCombinedDescription: 'مدرسه ایی یافت نشد.', strCity: '000x' });

    }, 100);

    form.value.strCity = this.list_StudentData?.strCity;

    Object.keys(form.value).forEach((key) => {

      this.mdlSchool.get(key)?.setValue(form.value[key])

    })

    if (this.mdlSchool.valid) {

      this.OtherService.Showspinner()

      let res = JSON.parse((await axios.post(`School_List`, this.OtherService.stringNumberToNumber(this.mdlSchool.value))).data.toString());

      this.OtherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this.OtherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

        return;

      }

      if (res.iResult == 0) return this.Notification.showError(res.strError);

      if (!res.length) return

      // this.Notification.showError('مدرسه ایی با این مشخصات یافت نشد!');

      this.list_Schools = res;


    }

  }

  private _filter(value: string): string[] {

    const filterValue = value

    this.selectedSchool = this.list_Schools.filter((option: { strComment: string | string[]; }) => option.strComment.includes(filterValue));

    return this.selectedSchool

  }


}
